export const options = [
  {
    label: "1970s",
    value: 1970
  },
  {
    label: "1980s",
    value: 1980
  },
  {
    label: "1990s",
    value: 1990
  },
  {
    label: "2000s",
    value: 2000
  },
  {
    label: "2010s",
    value: 2010
  },
  {
    label: "2020s",
    value: 2020
  }
];
